<template>
    <nav aria-label="Progress" class="hidden lg:block">
        <ol role="list" class="p-4 sm:p-0 sm:space-y-4 mb-6 md:flex md:space-y-0 md:space-x-8 grid gap-2" :class="gridCols">
            <li v-for="race in meeting.races" :key="race.id" class="col-span-1 md:flex-1 cursor-pointer" @click="store.commit('updateSelectedRace', race.number)">
                <div v-if="race.number === store.state.play.selectedRace" class="text-center sm:text-left sm:pl-4 py-2 flex flex-col border-gray-600 md:pl-0 md:pb-4 md:pb-0 border-b-4 transition duration-500 ease-in-out dark:border-racing-stars-yellow" aria-current="race">
                    <span class="text-xs text-gray-700 font-semibold tracking-wide uppercase md:pb-4 transition duration-500 ease-in-out dark:text-racing-stars-yellow"><span class="hidden sm:inline-block sm:mr-2">Race </span>{{ race.number }}</span>
                </div>
                <div v-else-if="store.state.play.selectedRunners.includes(race.id)" class="group text-center sm:text-left py-2 flex flex-col border-gray-900 hover:border-gray-900 md:pl-0 md:pb-4 md:pb-0 border-b-4 transition duration-500 ease-in-out dark:border-gray-200">
                    <span class="text-xs text-gray-900 font-semibold tracking-wide uppercase group-hover:text-gray-900 md:pb-4 transition duration-500 ease-in-out dark:text-gray-200 dark:group-hover:text-gray-200"><span class="hidden sm:inline-block sm:mr-2">Race </span>{{ race.number }}</span>
                </div>
                <div v-else class="group text-center sm:text-left py-2 flex flex-col border-gray-200 hover:border-gray-300 md:pl-0 md:pb-4 md:pb-0 border-b-4">
                    <span class="text-xs text-gray-500 font-semibold tracking-wide uppercase group-hover:text-gray-700 md:pb-4 transition duration-500 ease-in-out dark:text-white dark:group-hover:text-white"><span class="hidden sm:inline-block sm:mr-2">Race </span>{{ race.number }}</span>
                </div>
            </li>

            <li v-if="!meeting.finished_at && !meeting.abandoned" class="mt-4 col-span-7 cursor-pointer w-full md:flex-1 col-span-4 md:grid-cols-8" @click="store.commit('updateSelectedRace', 0)">
                <div v-if="store.state.play.selectedRace === 0" class="text-center sm:text-left sm:pl-4 py-2 flex flex-col border-gray-900 md:pl-0 md:pb-4 md:pb-0 border-b-4 transition duration-500 ease-in-out dark:border-racing-stars-yellow" aria-current="race">
                    <span class="text-xs text-gray-500 font-semibold tracking-wide uppercase group-hover:text-gray-700 md:pb-4 transition duration-500 ease-in-out dark:text-racing-stars-yellow">Place Bet</span>
                </div>
                <div v-else class="group sm:pl-4 py-2 flex flex-col border-gray-200 hover:border-gray-300 md:pl-0 md:pb-4 md:pb-0 border-b-4">
                    <span class="text-center sm:text-left text-xs text-gray-500 font-semibold tracking-wide uppercase group-hover:text-gray-700 md:pb-4 transition duration-500 ease-in-out dark:text-white dark:group-hover:text-white">Place Bet</span>
                </div>
            </li>
        </ol>
    </nav>

    <!-- Mobiel -->
    <nav aria-label="Progress" class="lg:hidden">
        <ol role="list" class="mb-6">
            <div class="grid gap-0 grid-flow-col">
                <li v-for="race in meeting.races" :key="race.id" class="col-span-1 cursor-pointer" @click="store.commit('updateSelectedRace', race.number)">
                    <div v-if="race.number === store.state.play.selectedRace" class="bg-racing-stars-yellow flex" aria-current="race">
                        <span class="flex w-full h-14 items-center justify-center"><span class="flex">R</span>{{ race.number }}</span>
                    </div>
                    <div v-else-if="store.state.play.selectedRunners.includes(race.id)" class="dark:border-stars-yellow bg-gray-800 border-b flex text-white">
                        <span class="flex w-full h-14 items-center justify-center"><span class="flex">R</span>{{ race.number }}</span>
                    </div>
                    <div v-else class="bg-gray-800 flex text-white">
                        <span class="flex w-full h-14 items-center justify-center"><span class="flex">R</span>{{ race.number }}</span>
                    </div>
                </li>
            </div>

            <div v-if="!meeting.finished_at && !meeting.abandoned" class="grid gap-0">
                <li class="cursor-pointer text-center" @click="store.commit('updateSelectedRace', 0)" :class="colSpan">
                    <div v-if="store.state.play.selectedRace === 0" class="bg-racing-stars-yellow text-gray p-4 group flex flex-col border-gray-200 border-b-4" aria-current="race">
                        <span class="">Confirm Selections</span>
                    </div>
                    <div v-else class="bg-gray-600 text-white p-4 group flex flex-col border-gray-200 border-b-4">
                        <span class="">Confirm Selections</span>
                    </div>
                </li>
            </div>
        </ol>
    </nav>
    <div v-for="race in meeting.races" :key="race.id" v-show="store.state.play.selectedRace === race.number">
        <meeting-details :meeting="meeting" :race="race" />
        <runners :non-runners="nonRunners" :reserves="reserves" :runners="race.runners" :race="race" />
    </div>
    <confirm v-show="store.state.play.selectedRace === 0" :runners="store.state.play.selectedRunners" :user="user" />
</template>
<script>
import { ref, reactive, onMounted, getCurrentInstance, computed } from 'vue'
import MeetingDetails from './MeetingDetails.vue'
import Runners from './Runners.vue'
import Confirm from './Confirm.vue'
import { useStore } from 'vuex'
import { CheckIcon } from '@heroicons/vue/outline'

export default {
    props: {
        meeting: Object,
        nonRunners: Object,
        reserves: Object,
        user: Object,
    },

    setup(props) {
        /*
        |--------------------------------------------------------------------------
        | Properties
        |--------------------------------------------------------------------------
        */

        const store = useStore()

        const gridCols = computed(() => {
            let number = props.meeting.races.length

            return 'grid-cols-'+number
        })

        const colSpan = computed(() => {
            let number = props.meeting.races.length

            return 'col-span-'+number
        })

        /**
         * @return {Object}
         */
        return {
            store,
            gridCols,
            colSpan,
        }

    },

    /**
     * The required components.
     *
     * @type {Object}
     */
    components: {
        MeetingDetails,
        Runners,
        Confirm,
        CheckIcon,
    }
}

</script>
